import { render, staticRenderFns } from "./VuesticCheckbox.vue?vue&type=template&id=3f377e4c"
import script from "./VuesticCheckbox.vue?vue&type=script&lang=js"
export * from "./VuesticCheckbox.vue?vue&type=script&lang=js"
import style0 from "./VuesticCheckbox.vue?vue&type=style&index=0&id=3f377e4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports